import { Box } from '@chakra-ui/react';
import { memo, useCallback } from 'react';

import { useTableStore } from './table.store';

export const TableRow: React.FC<any> = memo(({ row, ...props }) => {
  const { setHoveringRow, unsetHoveringRow } = useTableStore();

  const handleHover = useCallback(
    (rowId: string) => {
      setHoveringRow(rowId);
    },
    [setHoveringRow],
  );

  return (
    <Box
      onMouseEnter={() => {
        handleHover(row.id);
      }}
      onMouseLeave={() => {
        unsetHoveringRow();
      }}
      {...props}
    />
  );
});
